import React from "react";
import { motion } from "framer-motion";
import { Handshake, TrendingUp, LifeBuoy } from "lucide-react";
import "./WhyAdel.css";

const CARDS = [
  {
    icon: Handshake,
    title: "Connecting",
    body: "We bridge Kenyan talent with Middle East opportunity. Both sides meet someone who understands their needs.",
  },
  {
    icon: TrendingUp,
    title: "Placing",
    body: "5,000+ placements. Every one matched for skill, attitude, and fit. We don't place volume—we place people.",
  },
  {
    icon: LifeBuoy,
    title: "Supporting",
    body: "From visa paperwork to first-month check-ins, we stand alongside employer and worker. Placement is the start, not the end.",
  },
];

export default function WhyAdel() {
  return (
    <section className="why">
      <div className="container">
        <div className="why__header">
          <span className="eyebrow">Why Adel</span>
          <h2 className="why__title">
            One partner. Three things we do{" "}
            <span className="why__title-accent">exceptionally.</span>
          </h2>
        </div>

        <div className="why__grid">
          {CARDS.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.article
                key={c.title}
                className="why__card"
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{
                  duration: 0.6,
                  delay: i * 0.08,
                  ease: [0.22, 1, 0.36, 1],
                }}
                data-cursor="card"
              >
                <div className="why__card-rail" aria-hidden="true" />
                <div className="why__card-icon">
                  <Icon size={22} strokeWidth={1.6} />
                </div>
                <h3 className="why__card-title">{c.title}</h3>
                <p className="why__card-body">{c.body}</p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
